<template>
  <b-sidebar
    id="add-new-remark-sidebar"
    :visible="isAddNewRemarkSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-remark-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ button_text }} 備註</h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <!-- Body -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-overlay
          :show="loading"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small
          rounded="sm"
        >
          <!-- Form -->
          <b-form
            class="p-2"
            @submit.prevent="handleSubmit(onSubmit)"
            @reset.prevent="resetForm"
          >
            <!-- 標題-->
            <validation-provider
              #default="validationContext"
              name="此欄"
              rules="required"
              vid="v_title"
            >
              <b-form-group label="標題" label-for="title">
                <b-form-input
                  id="title"
                  v-model="remarkData.name"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder="標題"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <!-- Description1 -->
            <validation-provider
              #default="validationContext"
              name="此欄"
              rules="required"
              vid="v_content"
            >
              <b-form-group label="內容" label-for="content">
                <b-form-textarea
                  id="content"
                  v-model="remarkData.description"
                  placeholder="備註"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <validation-provider
              #default="validationContext"
              name="此欄"
              rules="required"
              vid="v_sort_order"
            >
              <b-form-group label="排序">
                <b-form-input
                  type="text"
                  placeholder="排序"
                  v-model="remarkData.sort_order"
                  :state="getValidationState(validationContext)"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <b-form-group
              label="狀態"
              label-for="is_active"
              label-cols-md="3"
              class="mt-2"
            >
              <!-- <b-form-input id="is_active"  v-model="remarkData.is_active" /> -->
              <b-form-checkbox
                :checked="remarkData.is_active"
                name="is_active"
                switch
                inline
                v-model="remarkData.is_active"
                value="1"
                style="margin-top: 5px"
              >
                {{ remarkData.is_active ? "啟用" : "禁用" }}
              </b-form-checkbox>
            </b-form-group>

            <div class="d-flex mt-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2"
                type="submit"
              >
                {{ button_text }}
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
              >
                取消
              </b-button>
            </div>
          </b-form>
        </b-overlay>
      </validation-observer>
    </template></b-sidebar
  >
</template>
  
  
  <script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormTextarea,
  BFormCheckbox,
  BOverlay,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { ref, watch } from "@vue/composition-api";
import { required, alphaNum, email } from "@validations";
import { max } from "@/libs/validations.js";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import store from "@/store";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormTextarea,
    BFormCheckbox,
    vSelect,
    BOverlay,
    BInputGroup,
    BInputGroupAppend,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
    quillEditor,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: "isAddNewRemarkSidebarActive",
    event: "update:is-add-new-remark-sidebar-active",
  },
  props: {
    isAddNewRemarkSidebarActive: {
      type: Boolean,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      max,
    };
  },
  setup(props, { emit }) {
    const loading = ref(false);

    const blankRemarkData = {
        id: 0,
        title: "",
        content: "",
        is_active: 1,
        sort_order: 1,
    };
    const button_text = ref("新增");

    const remarkData = ref(JSON.parse(JSON.stringify(blankRemarkData)));

    const resetremarkData = () => {
      remarkData.value = JSON.parse(JSON.stringify(blankRemarkData));
    };

    const toast = useToast();

    watch(
      () => [props.id, props.isAddNewRemarkSidebarActive],
      () => {
        if (props.id > 0 && props.isAddNewRemarkSidebarActive) {
          remarkData.value = { ...props.data };

          if (remarkData.value.id > 0) {
            button_text.value = "修改";
          } else {
            button_text.value = "新增";
          }
        } else {
          button_text.value = "新增";
        }
      }
    );

    const onSubmit = () => {
      loading.value = true;
      store
        .dispatch("quotation-description/editQuotationDescription", remarkData.value)
        .then((response) => {
          loading.value = false;
          emit("update:is-add-new-remark-sidebar-active", false);
          emit("refetch-data");
          toast({
            component: ToastificationContent,
            props: {
              title: "Success",
              text: response.data.message,
              icon: "CheckIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          loading.value = false;
          toast({
            component: ToastificationContent,
            props: {
              title: "Fail",
              text: error.response.data.message,
              icon: "HeartIcon",
              variant: "danger",
            },
          });
        });
    };

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetremarkData);

    return {
      remarkData,
      onSubmit,
      refFormObserver,
      getValidationState,
      resetForm,
      button_text,
      loading,
    };
  },
};
</script>
  
  </script>
  
  <style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
#add-new-stage-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}

.ql-editor {
  height: 300px;
}

.input-group-text {
  padding: 0 1rem;
}
.demo_button {
  width: 100%;
  min-height: 35px;
}
</style>